import ModelConflictModal from './ModelConflictModal'
import modelConflictModalContainer from './modelConflictModalContainer'

export default modelConflictModalContainer(ModelConflictModal)
